import React from 'react'

function Terms() {
  return (
    <div>
      <h1>Terms</h1>
    </div>
  )
}

export default Terms
